!function($, window, document) {
    const $win = $(window), $doc = $(document), $body = $(document.body);
    var winScrollHeight = $win.scrollTop();
    const isMobile = () => window.matchMedia("(max-width: 767px)").matches, isTablet = () => window.matchMedia("(min-width: 768px) and (max-width: 1023px)").matches;
    new ResizeObserver((entries => {
        entries.forEach((entry => {
            $(entry.target).find(".nav__inner > ul > li:has(.nav__dd)").each(((index, item) => {
                const list = entry.target.querySelector(".nav__inner"), listWidth = list.offsetWidth, listOffset = list.offsetLeft, itemDdWidth = item.querySelector(".nav__dd ul").offsetWidth;
                let move = item.offsetLeft - listOffset;
                listWidth < move + itemDdWidth && (move = Math.max(0, listWidth - itemDdWidth)), 
                item.style.setProperty("--offset-left", move + "px");
            }));
        }));
    })).observe($(".nav-main")[0]);
    $(".js-search-expander").each(((index, searchHolder) => {
        const $searchHolder = $(searchHolder), $form = $(".widget-search .search form"), $searchInput = $form.find("input");
        let typingTimer;
        $searchHolder.find(".js-search-open").on("click", (e => {
            e.preventDefault(), $body.addClass("is-widget-search-field-visible"), $form.find("input").focus();
        })), $(document).on("click", ".js-search-close", (e => {
            e.preventDefault(), $body.removeClass("is-widget-search-field-visible").removeClass("is-widget-search-results-visible");
        })), $(document).on("keydown", (e => {
            "Escape" === e.key && $body.removeClass("is-widget-search-field-visible").removeClass("is-widget-search-results-visible");
        })), $form.on("submit", (function(e) {
            e.preventDefault();
            let searchVal = $("#search").val();
            $.ajax({
                url: window.location.href,
                data: {
                    search_term: searchVal
                },
                success: function(response) {
                    $(".widget-search .widget__body").html($(response).find(".widget-search .widget__body").html()), 
                    $(".widget-search .widget__foot").html($(response).find(".widget-search .widget__foot").html()), 
                    $body.addClass("is-widget-search-results-visible"), initFavoritesBtns();
                }
            });
        })), $searchInput.on("input", (function() {
            clearTimeout(typingTimer), typingTimer = setTimeout((() => {
                $searchInput.val().length >= 3 && $form.submit();
            }), 300);
        }));
    }));
    new ResizeObserver((entries => {
        entries.forEach((entry => {
            const headerRect = entry.target.getBoundingClientRect(), icoRect = entry.target.querySelector(".js-search-expander").getBoundingClientRect();
            $body.css({
                "--search-ico-pos-x": icoRect.left + icoRect.width + "px",
                "--search-ico-pos-y": icoRect.top - headerRect.top + icoRect.height / 2 + "px",
                "--header-din-height": headerRect.height + "px",
                "--header-din-offset": headerRect.top + "px"
            });
        }));
    })).observe(document.querySelector(".header"));
    $(".js-search").each(((_, searchHolder) => {
        const $searchHolder = $(searchHolder), $searchField = $searchHolder.find("input"), $searchClear = $searchHolder.find(".js-search__clear");
        $searchField.on("focusout", (e => {
            $searchHolder.toggleClass("has-value", !!e.currentTarget.value.length);
        })), $searchField.on("keyup", function debounce(func, wait) {
            let timeout;
            return function(...args) {
                clearTimeout(timeout), timeout = setTimeout((() => func.apply(this, args)), wait);
            };
        }((e => {
            const searchQuery = e.currentTarget.value.toLowerCase();
            $searchHolder.closest(".accordion__body").find(".checkboxes-list").each((function() {
                const $ul = $(this);
                let hasVisibleItems = !1;
                $ul.find("li").each((function() {
                    const $li = $(this);
                    $li.find("label").text().toLowerCase().includes(searchQuery) ? ($li.show(), hasVisibleItems = !0) : $li.hide();
                }));
                const $header = $ul.prev("p");
                hasVisibleItems ? ($ul.show(), $header.show()) : ($ul.hide(), $header.hide());
            }));
        }), 200)), $searchHolder.find("form").on("submit", (e => !1)), $searchClear.on("click", (e => {
            e.preventDefault(), $searchField.val("").focus().trigger("input"), $searchHolder.closest(".accordion__body").find(".checkboxes-list").each((function() {
                const $ul = $(this);
                $ul.show(), $ul.prev("p").show(), $ul.find("li").show();
            })), isMobile() || $body.removeClass("is-widget-search-field-visible").removeClass("is-widget-search-results-visible");
        }));
    })), $doc.on("click", ".js-accordion .accordion__head", (e => {
        const $this = $(e.currentTarget);
        if ((isMobile() || isTablet()) && $this.parents(".widget-base").length) {
            $this.parent(".accordion__section").addClass("is-expanded-mobile").siblings().removeClass("is-expanded-mobile").parent(".js-accordion").find(".accordion__section:not(.is-expanded-mobile)").addClass("is-hidden-mobile"), 
            $(".js-reset-filter-mobile").removeClass("d-none");
            const filterName = $this.children("p").first().html();
            $("#reset-filter-mobile--category-name").html(filterName);
        } else $this.parents(".accordion__section").toggleClass("is-expanded").find(".accordion__body").slideToggle();
    })), $(".js-reset-filter-mobile").on("click", (e => {
        e.preventDefault();
        const $currentDisplayedFilters = $(".filters").find(".accordion__section.is-expanded-mobile").first().find(".checkboxes-list");
        $currentDisplayedFilters.length > 0 && $currentDisplayedFilters.find("input:checked").each((function() {
            $(this).prop("checked", !1).trigger("change");
        }));
    })), $(".js-filters .js-filter-clear").on("click", (e => {
        e.preventDefault();
        const $jsFilters = $(e.currentTarget).parents(".js-filters");
        $jsFilters.find("input:checked").each((function() {
            $(this).prop("checked", !1), $(this).attr("checked", !1);
        })), $jsFilters.find(".accordion__head.has-filter").removeClass("has-filter"), $jsFilters.addClass("clear-clicked"), 
        $(".js-apply-filters").trigger("click");
    })), $('.js-filters .checkbox input[type="checkbox"], .js-filters .checkbox input[type="radio"]').on("change", (function() {
        let $allCheckboxes = $(this).parents(".checkboxes-list"), $checkboxesHead = $allCheckboxes.parents(".accordion__section").children(".accordion__head");
        $allCheckboxes.find('input[type="checkbox"]:checked').length > 0 || $allCheckboxes.find('input[type="radio"]:checked').length > 0 ? $checkboxesHead.addClass("has-filter") : $checkboxesHead.removeClass("has-filter");
    })), $(".js-close-search-widget").on("click", (e => {
        e.preventDefault(), $body.removeClass("is-widget-search-field-visible").removeClass("is-widget-search-results-visible");
    }));
    (() => {
        const $stickyTop = $(".sticky-top");
        let stickyTopInitialHeight = $stickyTop.outerHeight();
        winScrollHeight = $win.scrollTop(), $win.on("load", (() => {
            stickyTopInitialHeight = $stickyTop.outerHeight(), $stickyTop.css("--initial-height", stickyTopInitialHeight + "px"), 
            checkIsPageHasScroll(), $win.on("scroll resize", (() => {
                checkIsPageHasScroll();
            }));
        }));
    })();
    const $navCollection = $(".nav-collection"), $banner = $(".banner"), checkIsPageHasScroll = () => {
        const topElementsHeight = $navCollection.outerHeight() + $banner.outerHeight();
        (winScrollHeight = $win.scrollTop()) > topElementsHeight + 1 && $body.addClass("page-has-scroll"), 
        winScrollHeight < topElementsHeight - 1 && $body.removeClass("page-has-scroll");
    };
    let isFavAjaxRunning = null, favAjaxQueue = {};
    const initFavoritesBtns = () => {
        $(".js-favorites").each(((index, btnFavorites) => {
            $(btnFavorites).hasClass("is-init") || $(btnFavorites).on("click", (e => {
                e.preventDefault();
                const $this = $(e.currentTarget);
                $(`*[data-post-id="${$this.attr("data-post-id")}"]`).toggleClass("is-active");
                const userId = $this.data("user-id"), postId = $this.data("post-id");
                favAjaxQueue[postId] = $this.hasClass("js-favorites-remove"), isFavAjaxRunning && (isFavAjaxRunning.abort(), 
                isFavAjaxRunning = null), isFavAjaxRunning = $.ajax({
                    url: ajaxParams.ajax_url,
                    type: "POST",
                    data: {
                        action: "add_to_favorites",
                        security: ajaxParams.favorites_nonce,
                        user_id: userId,
                        posts: favAjaxQueue
                    },
                    success: () => {
                        favAjaxQueue = {};
                    }
                }), $this.hasClass("js-favorites-remove") && (1 === $this.closest(".row").find(".col-md-4").length ? $this.closest(".row").html("<h2>No Products set as Favourite!</h2>") : $this.closest(".col-md-4").remove()), 
                $this.addClass("is-init");
            }));
        }));
    };
    initFavoritesBtns();
    const createDropDownItem = itemData => {
        const bgc = $(itemData.element).attr("data-background");
        return bgc && bgc.length ? `<span style="background-color: ${bgc};"></span> ${itemData.text}` : itemData.text;
    };
    function setInfoboxStyles($element) {
        $element.css({
            "--infobox-offset-left": $element.offset().left + "px",
            "--infobox-width": $element.outerWidth() + "px"
        });
    }
    $("select:not(.search_customers):not(.cfw-no-select2)").length && ($("select:not(.search_customers):not(.cfw-no-select2)").selectric({
        disableOnMobile: !1,
        nativeOnMobile: !1,
        optionsItemBuilder: createDropDownItem,
        labelBuilder: createDropDownItem,
        maxHeight: 500
    }), $body.on("country_to_state_changed", (function() {
        $("select#calc_shipping_state").length > 0 && $("select#calc_shipping_state").selectric({
            disableOnMobile: !1,
            nativeOnMobile: !1,
            optionsItemBuilder: createDropDownItem,
            labelBuilder: createDropDownItem,
            maxHeight: 500
        });
    }))), $win.on("load", (() => {
        $body.addClass("is-loaded");
    })), $(".nav-main .nav__inner > ul > li:has(.nav__dd) > a ").on("click", (e => {
        if (isMobile() || isTablet()) {
            e.preventDefault();
            const $this = $(e.currentTarget);
            $this.parents(".widget-base.widget--menu").find(".widget__head .btn-back").html($this.html()), 
            $this.parent().toggleClass("is-expanded").siblings().removeClass("is-expanded");
        }
    })), $(".js-go-back-widget-main").on("click", (e => {
        e.preventDefault(), (isMobile() || isTablet()) && $(".nav-main .is-expanded").removeClass("is-expanded");
    })), $(".js-go-back-widget-filters").on("click", (e => {
        e.preventDefault(), (isMobile() || isTablet()) && ($(".accordion .is-expanded-mobile").removeClass("is-expanded-mobile").parents(".js-accordion").find(".accordion__section.is-hidden-mobile").removeClass("is-hidden-mobile"), 
        $(".js-reset-filter-mobile").addClass("d-none"));
    })), $(".js-nav-trigger").on("click", (e => {
        e.preventDefault(), $body.toggleClass("is-menu-expanded");
    })), $doc.on("click", ".js-popup-cart-toggle", (e => {
        isMobile() ? (e.stopImmediatePropagation(), $("body").removeClass("cfw-side-cart-open"), 
        window.location.href = $(e.currentTarget).attr("href")) : (e.preventDefault(), $body.toggleClass("is-cart-expanded"));
    })), $(".js-filter-toggle-mobile, .js-filter-toggle-mobile span").on("click", (e => {
        e.preventDefault(), $body.toggleClass("is-filters-expanded");
    })), $(".infobox .infobox__head").on("click mouseenter", (e => {
        if (e.preventDefault(), ("mouseover" === e.type || "mouseenter" === e.type) && (isMobile() || isTablet())) return;
        const $this = $(e.currentTarget).parent();
        setInfoboxStyles($this), (isMobile() || isTablet()) && ($this.toggleClass("is-expanded"), 
        $(".infobox").each(((index, item) => {
            const $item = $(item);
            $item.html() !== $this.html() && $item.removeClass("is-expanded");
        })));
    })), $(window).on("resize", (() => {
        $(".infobox").each((function() {
            setInfoboxStyles($(this));
        }));
    })), $(".js-sort-toggle-mobile").on("click", (e => {
        (isMobile() || isTablet()) && (e.preventDefault(), $body.toggleClass("is-sort-expanded"));
    })), $(".section-all-products .form--sort-field").on("change", "select", (function() {
        const selectedSort = $(this).val(), url = new URL(window.location.href), params = new URLSearchParams(url.search);
        return params.set("sort-by", selectedSort), url.search = params.toString(), window.location.href = url.toString(), 
        !1;
    })), $("body").on("click", ".module--section-all-products.js-sort a", (function(e) {
        e.preventDefault();
        const selectedSort = $(this).parents(".js-sort").find(".checkboxes-list input:checked").val(), url = new URL(window.location.href), params = new URLSearchParams(url.search);
        return params.set("sort-by", selectedSort), url.search = params.toString(), window.location.href = url.toString(), 
        !1;
    })), $(".section-all-products .js-apply-filters").on("click", (function() {
        const url = new URL(window.location.href), params = new URLSearchParams(url.search), newParams = new URLSearchParams;
        let $selectedSortField, selectedSort;
        return $selectedSortField = isMobile() || isTablet() ? $(".section-all-products .js-sort input[type=radio]:checked") : $(".section-all-products .form--sort-field select"), 
        params.forEach(((value, key) => {
            key.startsWith("category") && newParams.append(key, value);
        })), $(".js-filters .js-accordion .checkboxes-list").each((function() {
            let filterName, $this = $(this), selectedValues = [];
            $this.find("input[type=checkbox]:checked, input[type=radio]:checked").each((function() {
                filterName = $(this).attr("name").replace(/\[\]$/, ""), selectedValues.push($(this).val());
            })), filterName && selectedValues.length > 0 && newParams.set(filterName, selectedValues.join(","));
        })), $(".js-filters").hasClass("clear-clicked") && newParams.set("clear", "1"), 
        $selectedSortField.length > 0 && (selectedSort = $selectedSortField.val(), newParams.set("sort-by", selectedSort)), 
        url.pathname = url.pathname.replace(/\/page\/\d+\//, "/"), url.search = newParams.toString(), 
        window.location.href = url.toString(), !1;
    })), $(".js-nav-aside-scroll .nav-tabs a").on("click", (e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        $this.parent().addClass("active").siblings().removeClass("active");
        const id = $this.attr("href").slice(1), $target = $(`[data-id=${id}]`);
        $target.length && window.scrollTo(0, $target.eq(0).offset().top);
    })), $(".js-close-banner").on("click", (e => {
        e.preventDefault(), $(e.currentTarget).parents(".banner").slideUp(100), $(e.currentTarget).parents(".banner-sticky").slideUp(100);
    })), $(".js-mobile-tabs .section__tabs-nav ul li").on("click", (e => {
        if (isMobile() || isTablet()) {
            e.preventDefault();
            const $this = $(e.currentTarget), index = $this.index();
            $this.addClass("is-active").siblings().removeClass("is-active"), $this.parents(".js-mobile-tabs").find(".section__tabs-body > * > *").eq(index).addClass("is-active").siblings().removeClass("is-active");
        }
    })), $win.on("load", (() => {
        $body.addClass("is-loaded"), "#favourites" === window.location.hash && ($("html, body").scrollTop(0), 
        $('.js-tabs a[href="#favourites"]').trigger("click"));
    })), $doc.on("click", ".counter .minus, .counter .plus", (function(e) {
        e.preventDefault();
        let $input = $(this).closest(".counter").find("input"), countNum = Number($input.val()), max = parseInt($input.attr("max")), isOverLimit = !1;
        countNum += $(this).hasClass("minus") ? -1 : 1, countNum > max && (isOverLimit = !0, 
        countNum = max), countNum < 1 && (countNum = 1), $input.val(countNum), $input.trigger("change"), 
        isOverLimit && alert("You’ve reached the maximum allowed quantity.");
    })), $(".js-slider-sync").each((function(i, el) {
        var $main = $(el).find(".slider-product .slider__slides"), $nav = $(el).find(".slider-product .slider__nav"), $lightbox = $(el).find(".lightbox"), $lightboxSlider = $(el).find(".js-slider-lightbox"), $lightboxOpen = $(el).find(".js-lightbox-open"), $lightboxClose = $(el).find(".js-lightbox-close");
        $($main).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            dots: !1,
            asNavFor: $nav,
            responsive: [ {
                breakpoint: 767,
                settings: {
                    dots: !0
                }
            } ]
        }), $($nav).slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: $main,
            dots: !1,
            arrows: !1,
            focusOnSelect: !0
        }), $($lightboxSlider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            arrows: !0
        }), $lightboxOpen.on("click", (function(e) {
            var currentSlide = $(this).parents(".slick-slide").data("slick-index");
            $lightboxSlider.slick("slickGoTo", currentSlide), $($lightbox).addClass("active");
        })), $lightboxClose.on("click", (function(e) {
            $(this).parents(".lightbox").removeClass("active");
        })), $(document).on("keydown", (function(event) {
            "Escape" === event.key && $lightbox.removeClass("active");
        }));
    }));
    $(".js-lightbox-single").each(((index, lightboxSingle) => {
        const $lightboxSingle = $(lightboxSingle);
        $lightboxSingle.hasClass("is-init") || ($lightboxSingle.on("click", (e => {
            e.preventDefault();
            const $this = $(e.currentTarget), $lightBox = $($this.attr("href"));
            $lightBox.addClass("active");
            const plyr = void 0 !== $lightBox.find(".plyr__wrapper")[0].plyr && $lightBox.find(".plyr__wrapper")[0].plyr;
            plyr && (plyr.play(), plyr.muted = !1);
        })), $lightboxSingle.addClass("is-init"));
    })), $("body").on("click", ".js-modal", (function(e) {
        e.preventDefault();
        var target = $(this).attr("href");
        $(target).addClass("active");
    })), $("body").on("click", ".js-lightbox-close", (function(e) {
        const $lightBox = $(this).parents(".lightbox");
        $lightBox.removeClass("active");
        const plyr = $lightBox.find(".plyr__wrapper")[0].plyr;
        plyr && plyr.pause();
    }));
    let $stickyInParent = $(".js-sticky-top");
    var lastScrollTop;
    function initStickySidebar(st, lastScrollTop) {
        0 != $(".sticky-content").length && $(".sticky-content").each((function(index, el) {
            var sidebarOffsetTop = $(el).parents(".sticky-content-holder").offset().top, headerHeight = 1.2 * $(".header").parents(".sticky-top").outerHeight(), sectionBottom = $(el).parents(".sticky-content-holder").offset().top + $(el).parents(".sticky-content-holder").outerHeight(), sidebarOffsetBottom = $(el).offset().top + $(el).outerHeight(), scrollTop = $win.scrollTop() + headerHeight;
            if (st > lastScrollTop) {
                if (scrollTop > sidebarOffsetTop && !$(el).hasClass("fixed")) {
                    var stickySidebarWidth = $(el).innerWidth();
                    $(el).addClass("fixed").css({
                        top: headerHeight,
                        bottom: "auto",
                        width: stickySidebarWidth
                    });
                }
                if (scrollTop < sidebarOffsetTop && $(el).hasClass("fixed")) {
                    stickySidebarWidth = $(el).innerWidth();
                    $(el).removeClass("fixed").css({
                        top: 0,
                        bottom: "auto",
                        width: "100%"
                    });
                }
                sidebarOffsetBottom > sectionBottom && !$(el).hasClass("bottom") && $(el).removeClass("fixed").addClass("bottom").css({
                    top: "auto",
                    bottom: 0,
                    width: "100%"
                });
            } else if (st < lastScrollTop) {
                if (scrollTop < $(el).offset().top) {
                    stickySidebarWidth = $(el).innerWidth();
                    $(el).addClass("fixed").removeClass("bottom").css({
                        top: headerHeight,
                        bottom: "auto",
                        width: stickySidebarWidth
                    });
                }
                scrollTop < sidebarOffsetTop && $(el).removeClass("fixed").css({
                    top: 0,
                    bottom: "auto",
                    width: "100%"
                }), scrollTop > sectionBottom && $(el).removeClass("fixed").addClass("bottom").css({
                    top: "auto",
                    bottom: 0,
                    width: "100%"
                });
            } else {
                if (scrollTop > sidebarOffsetTop && scrollTop < sectionBottom) {
                    stickySidebarWidth = $(el).innerWidth();
                    $(el).addClass("fixed").removeClass("bottom").css({
                        top: headerHeight,
                        bottom: "auto",
                        width: stickySidebarWidth
                    });
                }
                sidebarOffsetBottom > sectionBottom && $(el).removeClass("fixed").addClass("bottom").css({
                    top: "auto",
                    bottom: 0,
                    width: "100%"
                }), scrollTop < sidebarOffsetTop && $(el).removeClass("fixed").css({
                    top: 0,
                    bottom: "auto",
                    width: "100%"
                });
            }
        }));
    }
    $win.on("load scroll resize", (function() {
        winHeight = $win.innerHeight(), winScrollTop = $win.scrollTop(), $stickyInParent.each(((index, parent) => {
            let $parent = $(parent), parentOffsetTop = $parent.offset().top, parentHeight = $parent.outerHeight(), parentWidth = $parent.outerWidth(), childHeight = $parent.find(".sticky__item").outerHeight(), headerHeight = 0;
            headerHeight = isMobile() || isTablet() ? $(".sticky-top .sticky__din-height").outerHeight() : $(".sticky-top .sticky__din-height").outerHeight() - $(".nav-main").outerHeight(), 
            $parent.css({
                "--parent-width": parentWidth + "px",
                "--child-height": childHeight + "px",
                "--sticky-offset-top": headerHeight + "px"
            });
            let isSticky = winScrollTop + headerHeight >= parentOffsetTop, isStickyBottom = parentOffsetTop + parentHeight <= winScrollTop + headerHeight + childHeight;
            $parent.toggleClass("is-sticky", isSticky).toggleClass("is-sticky-bottom", isStickyBottom), 
            $(".box-edit .checklist").length && $body.css({
                "--sticky-element-height": childHeight + "px"
            });
        })), $(".js-sticky-banner-mobile").each((function() {
            var headerHeight = $(".sticky-top").outerHeight(), wrapperTop = $(this).parents(".wrapper-banner-sticky").offset().top, stickyHeaderBottom = $win.scrollTop() + headerHeight;
            stickyHeaderBottom >= wrapperTop && !$(this).hasClass("is-sticky") && ($(this).addClass("is-sticky"), 
            $(this).css("top", headerHeight + 24)), stickyHeaderBottom < wrapperTop && $(this).hasClass("is-sticky") && ($(this).removeClass("is-sticky"), 
            $(this).css("top", 0));
        })), $(".js-sticky-item").each((function() {
            var headerHeight = $(".sticky-top .sticky__din-height").outerHeight(), wrapperTop = $(this).parents(".wrapper-sticky-item").offset().top, stickyHeaderBottom = $win.scrollTop() + headerHeight;
            $(this).css("--top-pos", headerHeight + "px"), stickyHeaderBottom >= wrapperTop && !$(this).hasClass("is-sticky") && $(this).addClass("is-sticky"), 
            stickyHeaderBottom < wrapperTop && $(this).hasClass("is-sticky") && $(this).removeClass("is-sticky");
        }));
    })).on("load", (function() {
        $(".js-sticky-item").each((function() {
            var itemHeight = $(this).outerHeight();
            $(this).parents(".wrapper-sticky-item").css("--sticky-item-height", itemHeight + "px");
        }));
    })), $win.on("scroll", (function() {
        var st = $(this).scrollTop();
        initStickySidebar(st, lastScrollTop), lastScrollTop = st;
    })).on("resize load", (function() {
        setTimeout((function() {
            var st = $(this).scrollTop();
            initStickySidebar(st, lastScrollTop), lastScrollTop = st;
        }), 300);
    })), $(".js-cart__toggle").each((function() {
        var accCart = $(this), body = $(this).find(".cart__body"), button = $(this).find(".js-toggle");
        body.slideUp(), $(button).on("click", (function(e) {
            e.preventDefault(), $(body).slideToggle(), $(accCart).toggleClass("active");
        }));
    })), $(".js-tabs a").on("click", (function(e) {
        var target = $(this).attr("href");
        $(target) && (e.preventDefault(), $(this).parent().addClass("active").siblings().removeClass("active"), 
        $(target).addClass("active").siblings().removeClass("active"), $(".breadcrumbs ul li:last-child a").text($(this).text()));
    })), $win.on("load resize", (() => {
        $(".js-product-group").each(((_, productsGroup) => {
            let lastHeight = 0, lastOffsetTop = 0, setToProducts = [];
            const $products = $(productsGroup).find(".js-product");
            $products.each(((index, product) => {
                const $product = $(product), $productContent = $product.find(".product__content"), productHeight = $productContent.outerHeight(), productOffset = $productContent.offset().top;
                0 == index && (lastOffsetTop = productOffset), lastHeight < productHeight && (lastHeight = productHeight), 
                setToProducts.push({
                    $el: $product,
                    productHeight: productHeight
                });
                const $nextProduct = $products.eq(index + 1);
                if ($nextProduct.length) {
                    $nextProduct.offset().top > productOffset + 1 && (setToProducts.forEach((e => e.$el.eq(0).css("--spacer", lastHeight - e.productHeight + "px"))), 
                    setToProducts = [], lastHeight = 0, lastOffsetTop = productOffset);
                } else setToProducts.forEach((e => e.$el.eq(0).css("--spacer", lastHeight - e.productHeight + "px"))), 
                setToProducts = [], lastHeight = 0, lastOffsetTop = 0;
            }));
        }));
    }));
    $win.on("load resize scroll", (function() {
        if ((() => {
            const footer = $(".footer"), footerOffset = footer.offset()?.top, winHeight = $win.height(), footerIsVisible = $win.scrollTop() + winHeight > footerOffset;
            $body.toggleClass("is-footer-visible", footerIsVisible);
        })(), $win.scrollTop() < $(".sticky-top").offset().top) setTimeout((function() {
            var headerHeight = $(".header").offset().top + $(".header").outerHeight() - $win.scrollTop() + 24;
            $(".banner-sticky").css("--top-position", headerHeight + "px");
        }), 200); else {
            var headerHeight = $(".header").offset().top + $(".header").outerHeight() - $win.scrollTop() + 24;
            $(".banner-sticky").css("--top-position", headerHeight + "px");
        }
    }));
    const popup = document.getElementById("modal-delay");
    let isPopupDelayHasShow = !1;
    function showPopup() {
        isMobile() && $body.hasClass("is-menu-expanded") || ("true" !== sessionStorage.getItem("isPopupDelayHasShow") ? (isPopupDelayHasShow = !0, 
        sessionStorage.setItem("isPopupDelayHasShow", "true"), $(popup).addClass("active")) : isPopupDelayHasShow = !0);
    }
    const isMouseStopMove = ((func, delay) => {
        let timer;
        return function() {
            clearTimeout(timer), timer = setTimeout((() => {
                func.apply(this, arguments);
            }), delay);
        };
    })((() => {
        isPopupDelayHasShow || showPopup();
    }), 2e3);
    document.addEventListener("mousemove", (function(e) {
        if (isPopupDelayHasShow) return;
        (function isNearBrowserEdge(x, y) {
            const isNearTop = y <= 50, isNearRight = x >= window.innerWidth - 50;
            return isNearTop || isNearRight;
        })(e.clientX, e.clientY) && showPopup(), isMouseStopMove();
    })), document.addEventListener("mouseleave", (function() {
        isPopupDelayHasShow || showPopup();
    }));
    $win.on("load scroll resize ", (() => {
        $(".js-animate").each(((index, element) => {
            let $this = $(element), animateStart = $this.attr("data-start");
            $this.offset().top + $this.outerHeight() * animateStart < $win.scrollTop() + $win.outerHeight() && $this.addClass("is-animated");
        }));
    })), $doc.on("click", ".js-set-store", (function(event) {
        event.preventDefault();
        const $this = $(this), userId = $this.data("user-id"), postId = $this.data("post-id");
        $.ajax({
            url: ajaxParams.ajax_url,
            type: "POST",
            data: {
                action: "assign_store",
                security: ajaxParams.assign_store_nonce,
                user_id: userId,
                post_id: postId
            },
            success: function(response) {
                response.success ? ($(".js-set-store").text("Set as My Store"), $(".js-set-store").removeClass("selected"), 
                $this.text(response.data), $this.addClass("selected")) : ($(".js-set-store").text("Set as My Store"), 
                $this.append(response.data || "An error occurred."));
            }
        });
    })), function clickAndCollectCleanup() {
        if ($(".product__options .option-product").length > 0) {
            !1 === $(".product__options .option-product").data("delivery-available") && $(".js-add-to-cart").addClass("disabled").prop("disabled", !0);
        }
        $doc.on("change", "input#click-collect", (function(e) {
            const $this = $(this), $clickAndCollectToggle = $this.parents(".click-and-collect-toggle"), $disabledTick = $clickAndCollectToggle.children(".click-and-collect-toggle--disabled"), $enabledTick = $clickAndCollectToggle.children(".click-and-collect-toggle--enabled"), $labelButton = $clickAndCollectToggle.children("label").first().children("span.btn"), $availabilityReveal = $clickAndCollectToggle.parents(".availability").next(".availability-reveal");
            $clickAndCollectToggle.parents(".option-product").data("delivery-inventory-id");
            1 == $this.prop("checked") ? ($disabledTick.removeClass("active"), $enabledTick.addClass("active"), 
            $labelButton.removeClass("btn--outline").html("Selected"), $availabilityReveal.slideDown()) : ($disabledTick.addClass("active"), 
            $enabledTick.removeClass("active"), $labelButton.addClass("btn--outline").html("Select"), 
            $availabilityReveal.slideUp()), $("#click-and-collect--select").trigger("change");
        })), $doc.on("change", "#click-and-collect--select", (function(e) {
            const $this = $(this), selectedInventoryID = $this.val();
            $(".option-product").data("delivery-available");
            if (selectedInventoryID && 0 != selectedInventoryID) $(".js-add-to-cart").data("inventory-id", selectedInventoryID).removeClass("disabled").prop("disabled", !1); else {
                let defaultDeliveryInventoryID = $this.parents(".option-product").data("delivery-inventory-id");
                void 0 === defaultDeliveryInventoryID && (defaultDeliveryInventoryID = 0), $(".js-add-to-cart").data("inventory-id", defaultDeliveryInventoryID).addClass("disabled").prop("disabled", !0);
            }
        }));
    }(), $doc.on("click", ".js-add-to-cart", (function(event) {
        event.preventDefault();
        let button = $(this), productId = button.data("product-id"), inventoryId = button.data("inventory-id");
        if (0 == inventoryId) return !1;
        let refreshWindow = !1;
        button.hasClass("add-to-cart-refresh") && (refreshWindow = !0), button.text("Adding..."), 
        button.removeClass("btn--ico-plus");
        let quantity = 0;
        if (button.hasClass("js-order-again")) {
            let thisStep = button.data("step-number");
            const qtyField = $("#counter-step-" + thisStep + "-" + productId);
            quantity = $(qtyField).val();
        } else quantity = $(".product-quantity").val();
        void 0 === quantity && (quantity = 1), $.ajax({
            url: ajaxParams.ajax_url,
            type: "POST",
            data: {
                action: "add_to_cart",
                nonce: ajaxParams.add_to_cart_nonce,
                product_id: productId,
                quantity: quantity,
                inventory_id: inventoryId,
                woocommerce_multi_inventory_inventory: inventoryId
            },
            success: function(response) {
                response.success ? (button.text("In Cart"), $.ajax({
                    url: window.location.href,
                    success: function(result) {
                        $(".popup-aside").html($(result).find(".popup-aside").html()), $(".review__items").html($(result).find(".review__items").html()), 
                        $(".js-popup-cart-toggle").removeClass("cart-empty"), $(document.body).trigger("wc_fragment_refresh"), 
                        $(document.body).trigger("updated_cart_totals"), refreshWindow && location.reload();
                    }
                })) : button.text("Error Adding to Cart");
            }
        });
    })), $(document).on("click", ".quantity__btn", (function(e) {
        e.preventDefault();
        let $qtyInput = $(this).siblings(".qty"), quantity = parseInt($qtyInput.val());
        quantity += $(this).hasClass("quantity__btn-plus") ? 1 : -1;
        let min = parseInt($qtyInput.attr("min")), max = parseInt($qtyInput.attr("max"));
        max = isNaN(max) ? 9999 : max, min = isNaN(min) ? 1 : min, quantity < 1 ? quantity = min : quantity > max && (quantity = max), 
        $qtyInput.val(quantity).trigger("change");
    }));
    let ajaxHolder = null, ajaxSubHolder = null;
    $(document).on("input change", ".popup-aside input.qty, .builder__body .productlist__body .counter__field input[type=number]", (function(e) {
        null !== ajaxHolder && (ajaxHolder.abort(), ajaxHolder = null), null !== ajaxSubHolder && (ajaxSubHolder.abort(), 
        ajaxSubHolder = null);
        const qty = $(e.currentTarget).val(), id = $(e.currentTarget).attr("id").replace("cart-", "").replace("-qty", "");
        ajaxHolder = $.ajax({
            url: ajaxParams.ajax_url,
            method: "POST",
            data: {
                action: "efr_update_cart_item_qty",
                item: id,
                qty: qty
            },
            success: response => {
                response.success && (ajaxSubHolder = $.ajax({
                    url: window.location.href,
                    success: function(result) {
                        $(".popup-aside").html($(result).find(".popup-aside").html()), $(".builder__body .productlist__body").html($(result).find(".builder__body .productlist__body").html()), 
                        $(".review__items").html($(result).find(".review__items").html()), $(document.body).trigger("wc_fragment_refresh"), 
                        $(document.body).trigger("updated_cart_totals");
                    }
                }));
            }
        });
    }));
    let isAjaxRunning = !1;
    $(document).on("click", ".popup-aside .product__remove a", (function(e) {
        if (e.preventDefault(), $(".cart-list .cart__body").addClass("loading-overlay"), 
        isAjaxRunning) return;
        isAjaxRunning = !0;
        const url = $(this).attr("href");
        $.ajax({
            url: url,
            beforeSend: () => {
                $(this).closest("li").fadeOut();
            },
            success: response => {
                $.ajax({
                    url: window.location.href,
                    success: function(result) {
                        $(".popup-aside").html($(result).find(".popup-aside").html()), $(document.body).trigger("wc_fragment_refresh"), 
                        $(document.body).trigger("updated_cart_totals"), $(".cart-list .cart__body").removeClass("loading-overlay");
                    }
                });
            },
            complete: () => {
                isAjaxRunning = !1;
            }
        });
    })), $(".profile__accordion").on("click", ".js-remove-from-routine", (e => {
        e.preventDefault();
        const $this = $(e.currentTarget), removeProductId = $this.data("remove-product-id"), removeStepNumber = $this.data("remove-step-number");
        isAjaxRunning || (isAjaxRunning = !0, $this.html("Removing...").prop("disabled", !0).addClass("disabled"), 
        $.ajax({
            url: ajaxParams.ajax_url,
            type: "POST",
            data: {
                product_id: removeProductId,
                action: "remove_from_routine",
                security: ajaxParams.remove_from_routine_nonce
            },
            success: result => {
                $.ajax({
                    url: window.location.href,
                    type: "GET",
                    success: function(result) {
                        $("#step" + removeStepNumber).html($(result).find("#step" + removeStepNumber).html()).find(".accordion__body").css("display", "block");
                    }
                });
            },
            complete: () => {
                isAjaxRunning = !1, $this.html("Remove").prop("disabled", !1).removeClass("disabled");
            }
        }));
    })), $("body").on("click", ".js-coupon .js-coupon-trigger", (e => {
        e.preventDefault(), $(e.currentTarget).siblings(".coupon__controls").slideToggle().parents(".js-coupon").toggleClass("is-expanded");
    })), $("body").on("click", ".js-script-coin-trigger", (e => ($(e.currentTarget).siblings(".js-script-coin-apply-to-order").slideToggle().parents(".cart__total--script-coin").toggleClass("is-expanded"), 
    !1))), $(".popup-aside, .review__body").on("click", ".js-script-coin-apply-to-order button", (function(e) {
        const $this = $(e.currentTarget), scriptCoinAmount = $this.siblings("input.script-coin-amount").val();
        if (isAjaxRunning) return;
        isAjaxRunning = !0;
        let parent = "popup-aside";
        return $this.parents(".review__body").length > 0 && (parent = "review-body"), $this.html("Applying...").prop("disabled", !0).addClass("disabled"), 
        $(".cart-list").addClass("loading-overlay"), $.ajax({
            url: ajaxParams.ajax_url,
            type: "POST",
            data: {
                action: "apply_script_coin_to_order",
                amount: scriptCoinAmount,
                security: ajaxParams.apply_script_coin_nonce
            },
            success: result => {
                if (!1 === result.success) alert("Could not apply Script Coin balance: " + result.data.message), 
                $(".cart-list").removeClass("loading-overlay"); else {
                    if ("review-body" == parent) return location.reload(), !1;
                    $.ajax({
                        url: window.location.href,
                        type: "GET",
                        success: function(result) {
                            $(".popup-aside").html($(result).find(".popup-aside").html()), $body.trigger("update_checkout"), 
                            $body.trigger("wc_fragment_refresh"), $("body").trigger("updated_cart_totals"), 
                            $(".cart-list").removeClass("loading-overlay");
                        }
                    });
                }
            },
            complete: () => {
                isAjaxRunning = !1, $this.html("Apply").prop("disabled", !1).removeClass("disabled");
            }
        }), !1;
    }));
    const action = new URLSearchParams(window.location.search).get("action");
    "edit" !== action && "password" !== action || $(".js-edit-account-form").slideDown(), 
    $(".js-add-shipping").on("click", (function(e) {
        e.preventDefault(), $(".js-shipping-form").slideToggle();
    })), $(".js-add-billing").on("click", (function(e) {
        e.preventDefault(), $(".js-billing-form").slideToggle();
    })), $("form.login").on("submit", (function() {
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set("form", "login"), window.history.replaceState(null, "", newUrl);
    })), $("form.register").on("submit", (function() {
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set("form", "register"), window.history.replaceState(null, "", newUrl);
    })), $win.on("load", (() => {
        $(".section-articles .section__body > .row").isotope({
            itemSelector: ".col-md-4",
            percentPosition: !0,
            masonry: {
                columnWidth: ".col-md-4"
            }
        });
    })), $("body").on("change", ".product__options .option__select--color select", (function() {
        window.location.href = $(this).val();
    })), $("body").on("click", ".js-remove-item", (function(e) {
        e.preventDefault(), 1 === $(this).parents(".productlist__body").find(".product-cart").length ? $(this).parents(".accordion").remove() : $(this).parents("li").eq(1).remove();
    }));
}(jQuery, window, document);